import React from "react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";

export const SiteFooter = () => {
  const { t, language } = useLanguage();

  return (
    <footer className="border-t border-border px-6 py-10" data-testid="site-footer">
      <div className="container mx-auto flex max-w-6xl flex-col items-center justify-between gap-4 md:flex-row">
        <p className="text-sm text-muted-foreground" data-testid="site-footer-copyright">
          {t("copyright")}
        </p>

        <div className="flex flex-wrap items-center justify-center gap-4 text-sm text-muted-foreground">
          <Link to="/terms" className="transition-colors hover:text-foreground" data-testid="site-footer-terms-link">
            {language === "es" ? "Términos y Condiciones" : "Terms and Conditions"}
          </Link>
          <Link to="/privacy" className="transition-colors hover:text-foreground" data-testid="site-footer-privacy-link">
            {language === "es" ? "Política de Privacidad" : "Privacy Policy"}
          </Link>
        </div>
      </div>
    </footer>
  );
};